// Path: ./src/app/components/ProtectedRoute/index.tsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { IsAuthenticated, verifyRole } from "../../../utils/IsAuthenticated";

// public route not access able when logged in for example login page etc
export const PublicRoute = () => {
  if (IsAuthenticated()) {
    return (
      <Navigate to="/dashboard" replace data-testid="publicroute-test-id" />
    );
  }

  return <Outlet data-testid="publicroute-test-id" />;
};

// protected route we can't access routes if user wasn't logged in
export const ProtectedRoute = () => {
  if (!IsAuthenticated()) {
    return (
      <Navigate to="/login" replace data-testid="protectedroute-test-id" />
    );
  }

  return <Outlet data-testid="protectedroute-test-id" />;
};

interface Props {
  groupName: string;
  roleName: string;
}
export const RoleBaseAccessRoute = ({ groupName, roleName }: Props) => {
  if (!IsAuthenticated()) {
    return (
      <Navigate to="/login" replace data-testid="rolebaseaccessroute-test-id" />
    );
  }
  if (verifyRole(groupName, roleName)) {
    return <Outlet data-testid="rolebaseaccessroute-test-id" />;
  }
  return (
    <Navigate
      to="/dashboard"
      replace
      data-testid="rolebaseaccessroute-test-id"
    />
  );
};

interface RedirectRouteProps {
  redirectTo: string;
  parentRoute: string;
}

export const RedirectRoute = ({
  redirectTo,
  parentRoute,
}: RedirectRouteProps) => {
  const location = useLocation();
  if (location.pathname === parentRoute) {
    return (
      <Navigate
        to={parentRoute + redirectTo}
        replace
        data-testid="redirectroute-test-id"
      />
    );
  }
  return <></>;
};
